import React from 'react';
import get from 'lodash.get';
import { Backdrop, Box, Typography, Grid } from '@kis-technologies/kis-ui';
import { Processing } from 'components/Processing';
import { SuccessText, useStyles } from '../styled';
import { ProcessingOverlayProps } from '../types';
import { selectors as configSelectors, Configuration } from 'services/configuration';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

/**
 * Processing Overlay is used during payment processing with API,
 * displays Processing Overlay - along with a success text, which is rendered
 * when the API call is successful
 */

export const ProcessingOverlay = (props: ProcessingOverlayProps) => {
  const { error, processed, processAction, title, onAnimationComplete } = props;
  const config = useSelector(configSelectors.selectConfiguration) as Configuration;
  const flow = get(config, 'configuration.flowTemplate', '');
  const fontFamily = get(config, 'configuration.globalSettings.fonts.primary', '');
  const classes = useStyles({ flow, fontFamily })();
  const { t } = useTranslation();

  React.useEffect(() => {
    processAction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEl = (el: HTMLElement) => {
    const { style } = el;
    style.background = '#EFEFEF';
  };

  return (
    <>
      {!error && (
        <Backdrop onEl={onEl} open>
          <Grid className={classes.processingContainer}>
            <Box fullWidth>
              {/* Processing Message */}
              <Typography className={classes.processingText}>{title}</Typography>
            </Box>
            {/* Processing SVG */}
            <Processing complete={processed} onAnimationComplete={onAnimationComplete} />

            {/* Success Text when API Purchase Success */}
            {processed && (
              <Box flexOverride="none" margin="7 0 0">
                <SuccessText complete={processed}>{t('processing.success')}</SuccessText>
              </Box>
            )}
          </Grid>
        </Backdrop>
      )}
    </>
  );
};
